// store/useMainStore.js
import { create } from "zustand";

const useDetectionRightStore = create((set) => ({
    // classes — the selected class itself lives in useDetectionStore
    // (currentClassId); this store only holds the Add/Edit popup state.
    classInfo: null,
    setClassInfo: (value) => { set({ classInfo: value }) },

    //   other 
    isModalOpen: null,
    setIsModalOpen: (value) => { set({ isModalOpen: value }) }
}));

export default useDetectionRightStore;